import { useCore } from '@/composables/core'

/*
 * trigger from JS console:
 * document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { detail: { name: "modal.mobileAppInstalled", data: { "mobile_app_installed": true } }}))
 */

const name = 'modal.mobileAppInstalled'

const callback = (data) => {
  if (data.mobile_app_installed) {
    const { store } = useCore()
    store.commit('app/setMobileAppInstalled', !!data.mobile_app_installed)
  }
}

export default { name, callback }
